export enum JobStatus {
  STARTED = 'started',
  PENDING = 'pending',
  FAILED = 'failed',
  PARTIALLY_FAILED = 'partially_failed',
  SUCCESS = 'success',
}
